export default __webpack_public_path__ + "static/Gov-Jersey-Crest-2c0417261ea8cd18185ca7c9e54c9f86.svg";